import { getPubAbbr } from "@revbox/helpers-fe";
import { TaxonomyModule } from "../../../../../modules/taxonomy";

export function TopBidCellRenderer({ value }) {
    return (
        <div className="align-items-center">
            {value}
        </div>
    );
}

export function TopBidCellColumnHeaderTooltipRenderer() {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);

    return taxonomy.tooltips.ppc_branding_column_headers.top_bid;
}

export function TopBidCellTooltipRenderer({ value }) {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);

    return taxonomy.tooltips.ppc_branding_column_inlines.top_bid;
}
 